import { get } from '@utils/lo/lo';

function parse(error) {
  return get(error, 'response.data.error', error.message);
}

export default parse;
